/**
 * flash-sale feature — public API
 */
export { flashSaleKeys } from "@/features/flash-sale/queries/keys";
export {
  useProductFlashSaleInfo,
  useProductFlashSaleSlug,
} from "@/features/flash-sale/queries/useFlashSale";
export { FlashSaleListContent } from "@/features/flash-sale/components/FlashSaleListContent";
export { FlashSaleDetailContent } from "@/features/flash-sale/components/FlashSaleDetailContent";
